import { apiPost } from "../ApiMethod";
import { setCampusData } from "../../mappers";

export const createCampus = async (data) => {
  const response = await apiPost("_campuses", data);
  return { ...response, data: setCampusData(response.data) };
};
